/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {Injectable} from '@angular/core';
import {SubscriptionTypeResourceService} from "@well/resource-services";

@Injectable({
  providedIn: 'root'
})
export class SubscriptionTypeListService {

  constructor(private subscriptionTypeResourceService: SubscriptionTypeResourceService) { }

  getList(event: any | null) {
   return this.subscriptionTypeResourceService.findAll(event);
  }
}
